module.exports = __webpack_public_path__ + "static/media/profile_pincode.78133563.svg";